// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dual-cta {
  padding: 72px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.dual-cta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.dual-cta-card {
  border-radius: 20px;
  padding: 44px 36px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dual-cta-card.client {
  background: #eef2ff;
}

.dual-cta-card.provider {
  background: #ecfdf5;
}

.dual-cta-deco {
  position: absolute;
  border-radius: 50%;
  opacity: 0.18;
}
.dual-cta-card.client .dual-cta-deco-1 { width: 180px; height: 180px; background: #4f46e5; top: -50px; right: -50px; }
.dual-cta-card.client .dual-cta-deco-2 { width: 100px; height: 100px; background: #818cf8; bottom: -20px; right: 80px; }
.dual-cta-card.provider .dual-cta-deco-1 { width: 180px; height: 180px; background: #059669; top: -50px; right: -50px; }
.dual-cta-card.provider .dual-cta-deco-2 { width: 100px; height: 100px; background: #34d399; bottom: -20px; right: 80px; }

.dual-cta-icon{width:48px;height:48px;border-radius:14px;display:flex;align-items:center;justify-content:center;position:relative;z-index:1}
.dual-cta-card.client .dual-cta-icon{background:rgba(79,70,229,0.12);color:#4f46e5}
.dual-cta-card.provider .dual-cta-icon{background:rgba(5,150,105,0.12);color:#059669}

.dual-cta-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.4px;
  line-height: 1.25;
  position: relative;
  z-index: 1;
}

.dual-cta-desc {
  font-size: 0.9rem;
  color: var(--muted);
  line-height: 1.6;
  position: relative;
  z-index: 1;
}

.dual-cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 12px;
  padding: 13px 22px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  font-family: inherit;
  width: fit-content;
  transition: opacity 0.2s, transform 0.15s;
  margin-top: 6px;
  position: relative;
  z-index: 1;
}
.dual-cta-btn:hover { opacity: 0.9; transform: translateY(-1px); }

.dual-cta-card.client .dual-cta-btn { background: #4f46e5; color: #fff; }
.dual-cta-card.provider .dual-cta-btn { background: #059669; color: #fff; }

@media (max-width: 640px) {
  .dual-cta-grid { grid-template-columns: 1fr; }
  .dual-cta-card { padding: 32px 24px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/DualCTA.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA,yCAAyC,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,UAAU,EAAE,YAAY,EAAE;AACrH,yCAAyC,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,aAAa,EAAE,WAAW,EAAE;AACvH,2CAA2C,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,UAAU,EAAE,YAAY,EAAE;AACvH,2CAA2C,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,aAAa,EAAE,WAAW,EAAE;;AAEzH,eAAe,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,YAAY,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,SAAS;AAC3I,qCAAqC,+BAA+B,CAAC,aAAa;AAClF,uCAAuC,+BAA+B,CAAC,aAAa;;AAEpF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA,sBAAsB,YAAY,EAAE,2BAA2B,EAAE;;AAEjE,sCAAsC,mBAAmB,EAAE,WAAW,EAAE;AACxE,wCAAwC,mBAAmB,EAAE,WAAW,EAAE;;AAE1E;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,iBAAiB,kBAAkB,EAAE;AACvC","sourcesContent":[".dual-cta {\n  padding: 72px 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dual-cta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.dual-cta-card {\n  border-radius: 20px;\n  padding: 44px 36px;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dual-cta-card.client {\n  background: #eef2ff;\n}\n\n.dual-cta-card.provider {\n  background: #ecfdf5;\n}\n\n.dual-cta-deco {\n  position: absolute;\n  border-radius: 50%;\n  opacity: 0.18;\n}\n.dual-cta-card.client .dual-cta-deco-1 { width: 180px; height: 180px; background: #4f46e5; top: -50px; right: -50px; }\n.dual-cta-card.client .dual-cta-deco-2 { width: 100px; height: 100px; background: #818cf8; bottom: -20px; right: 80px; }\n.dual-cta-card.provider .dual-cta-deco-1 { width: 180px; height: 180px; background: #059669; top: -50px; right: -50px; }\n.dual-cta-card.provider .dual-cta-deco-2 { width: 100px; height: 100px; background: #34d399; bottom: -20px; right: 80px; }\n\n.dual-cta-icon{width:48px;height:48px;border-radius:14px;display:flex;align-items:center;justify-content:center;position:relative;z-index:1}\n.dual-cta-card.client .dual-cta-icon{background:rgba(79,70,229,0.12);color:#4f46e5}\n.dual-cta-card.provider .dual-cta-icon{background:rgba(5,150,105,0.12);color:#059669}\n\n.dual-cta-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text);\n  letter-spacing: -0.4px;\n  line-height: 1.25;\n  position: relative;\n  z-index: 1;\n}\n\n.dual-cta-desc {\n  font-size: 0.9rem;\n  color: var(--muted);\n  line-height: 1.6;\n  position: relative;\n  z-index: 1;\n}\n\n.dual-cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  border-radius: 12px;\n  padding: 13px 22px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none;\n  font-family: inherit;\n  width: fit-content;\n  transition: opacity 0.2s, transform 0.15s;\n  margin-top: 6px;\n  position: relative;\n  z-index: 1;\n}\n.dual-cta-btn:hover { opacity: 0.9; transform: translateY(-1px); }\n\n.dual-cta-card.client .dual-cta-btn { background: #4f46e5; color: #fff; }\n.dual-cta-card.provider .dual-cta-btn { background: #059669; color: #fff; }\n\n@media (max-width: 640px) {\n  .dual-cta-grid { grid-template-columns: 1fr; }\n  .dual-cta-card { padding: 32px 24px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
